<div class="container">
  <mat-tab-group (selectedTabChange)="updateParams($event)">
    @for (warehouse of warehouses; track warehouse; let i = $index) {
      <mat-tab [label]="'Bodega: ' + warehouse.name">
        <div class="mt-4">
          <data-table
            [titleExcelFile]="'inventario'"
            [columns]="columnasI"
            [url]='urlTableI'
            [configuration]="configurationI"
            [reloadTable]="reloadTablaI[i]"
            [params]="params"
            [headerFileXlsm]="headerFileXlsm"
            [headerFilters]="headerFilters"
            (edit)="editStock($event, i)">
          </data-table>
        </div>
      </mat-tab>
    }
  </mat-tab-group>
</div>
